import { createTwc } from "react-twc";

import cn from "./cn";

export const html = createTwc({ compose: cn });
